document.addEventListener('DOMContentLoaded', () => {
  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;

  const sectionId = productInfo.dataset.section;
  if (!sectionId) return;

  // Captured once on load: Hyper drops ?view= from the URL when the variant changes,
  // and we need it so the Archive template's section is the one fetched.
  const templateView = new URLSearchParams(window.location.search).get('view');

  let isUpdating = false;
  let recheckAfterUpdate = false;

  // Variant ID sources, most reliable first. Never search the whole page:
  // other products' forms live there.
  const getVariantId = (preferredId) => {
    if (preferredId) return String(preferredId);

    const fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) return fromUrl;

    const scoped = productInfo.querySelector('input[name="id"]');
    return scoped && scoped.value ? scoped.value : null;
  };

  // The page already shows the initial variant, so no fetch is needed on load
  let lastVariantId = getVariantId();

  // -----------------------------
  // Toggle buttons (document-level, so they survive DOM replacement)
  // -----------------------------
  document.addEventListener('click', (e) => {
    // Collapsible tab table
    const accordionBtn = e.target.closest('.spec-view-more');
    if (accordionBtn) {
      const accordion = accordionBtn.closest('.variant-metafields-accordion');
      const table = accordion && accordion.querySelector('[data-collapsible-spec-table]');
      if (!table) return;

      table.classList.remove('is-restored');
      const expanded = table.classList.toggle('is-expanded');
      accordionBtn.setAttribute('aria-expanded', String(expanded));
      const label = accordionBtn.querySelector('.btn__text');
      if (label) label.textContent = expanded ? 'View Less' : 'View Full Specification';
      return;
    }

    // Standalone (Archive) table
    const standaloneBtn = e.target.closest('[data-spec-toggle]');
    if (standaloneBtn) {
      const wrapper = standaloneBtn.closest('[data-variant-standalone]');
      const table = wrapper && wrapper.querySelector('[data-spec-table]');
      if (!table) return;

      table.classList.remove('is-restored');
      const expanded = table.classList.toggle('is-expanded');
      standaloneBtn.setAttribute('aria-expanded', String(expanded));
      const label = standaloneBtn.querySelector('.btn__text');
      if (label) label.textContent = expanded ? 'View Less' : 'View Full Specification';
    }
  });

  // -----------------------------
  // Swap in fresh HTML
  // -----------------------------
  
  // Re-applies the expanded state to a freshly swapped-in table + button
  const restoreExpanded = (container, tableSelector, buttonSelector) => {
    const table = container.querySelector(tableSelector);
    const btn = container.querySelector(buttonSelector);
    if (!table) return;

    table.classList.add('is-expanded');
    table.classList.add('is-restored');
    if (btn) {
      btn.setAttribute('aria-expanded', 'true');
      const label = btn.querySelector('.btn__text');
      if (label) label.textContent = 'View Less';
    }
  };

  const replaceAccordions = (doc) => {
    const current = document.querySelectorAll('.variant-metafields-accordion');
    const source = doc.querySelectorAll('.variant-metafields-accordion');
    if (!current.length || !source.length) return;

    current.forEach((oldEl, i) => {
      const wasExpanded = !!oldEl.querySelector('[data-collapsible-spec-table].is-expanded');
      const replacement = (source[i] || source[0]).cloneNode(true);

      if (oldEl.hasAttribute('open')) {
        replacement.setAttribute('open', '');
        replacement.setAttribute('aria-expanded', 'true');
      }

      oldEl.replaceWith(replacement);

      if (wasExpanded) {
        restoreExpanded(replacement, '[data-collapsible-spec-table]', '.spec-view-more');
      }
    });
  };

  const replaceStandalone = (doc) => {
    const current = document.querySelectorAll('[data-variant-standalone]');
    const source = doc.querySelector('[data-variant-standalone]');
    if (!current.length || !source) return;

    current.forEach((el) => {
      const wasExpanded = !!el.querySelector('[data-spec-table].is-expanded');
      const replacement = source.cloneNode(true);

      el.replaceWith(replacement);

      if (wasExpanded) {
        restoreExpanded(replacement, '[data-spec-table]', '[data-spec-toggle]');
      }
    });
  };

  const replaceIconBoxValues = (doc) => {
    document.querySelectorAll('[data-icon-box-value]').forEach((el) => {
      const source = doc.querySelector(`[data-icon-box-value="${el.dataset.iconBoxValue}"]`);
      if (source) el.innerHTML = source.innerHTML;
    });
  };

  // -----------------------------
  // Fetch the section for the new variant
  // -----------------------------
  const update = async (preferredId) => {
    const variantId = getVariantId(preferredId);
    if (!variantId || variantId === lastVariantId) return;

    if (isUpdating) {
      recheckAfterUpdate = true;
      return;
    }

    isUpdating = true;

    try {
      const params = new URLSearchParams();
      if (templateView) params.set('view', templateView);
      params.set('section_id', sectionId);
      params.set('variant', variantId);

      const res = await fetch(`${window.location.pathname}?${params.toString()}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

      replaceAccordions(doc);
      replaceStandalone(doc);
      replaceIconBoxValues(doc);

      lastVariantId = variantId;
    } catch (err) {
      console.warn('[variant specs] update failed', err);
    } finally {
      isUpdating = false;
      if (recheckAfterUpdate) {
        recheckAfterUpdate = false;
        update();
      }
    }
  };

  // The theme updates the URL a moment after the click, so check a few times
  const checkSoon = (preferredId) => {
    [0, 150, 400, 800].forEach((delay) => setTimeout(() => update(preferredId), delay));
  };

  // -----------------------------
  // Triggers
  // -----------------------------
  productInfo.addEventListener('variant:change', (event) => {
    const id = event.detail && event.detail.variant && event.detail.variant.id;
    checkSoon(id);
  });

  productInfo.addEventListener('change', () => checkSoon());

  // Safety net: catches any other way the theme switches variant
  let observerTimer = null;
  new MutationObserver(() => {
    clearTimeout(observerTimer);
    observerTimer = setTimeout(() => update(), 200);
  }).observe(productInfo, { childList: true, subtree: true });
});